let navData = [
    {
        name: 'Home',
        route: '/dashboard'
    },
    {
        name: 'Analytics',
        route: '/analytics'
    },
    {
        name: 'Recommendations',
        route: '/recommendations'
    },
    // {
    //     name: 'Recurring',
    //     route: '/recurring'
    // },

]

export { navData }